@if (userService?.isAuthenticated != null) {
<mat-sidenav-container>
  <mat-sidenav #sidenav mode="push">
    <div class="branding tenant-bg-primary-color">
      <div class="tenant-logo">
      </div>
    </div>
    <mat-nav-list>
      @for (item of navigation; track item) {
      @if (item.isMenu) {
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{item.label | translate}}</mat-panel-title>
          </mat-expansion-panel-header>
          <mat-list>
            @for (subItem of item.items; track subItem) {
            <span [inspektRequiredPermission]="subItem.permissions">
              <a mat-list-item (click)="sidenav.close()" [routerLink]="[subItem.link]" routerLinkActive="active">
                {{subItem.label | translate}}
              </a>
            </span>
            }
          </mat-list>
        </mat-expansion-panel>
      </mat-accordion>
      }
      @else {
      <a mat-list-item class="sidenav-item" (click)="sidenav.close()" [routerLink]="[item.link]"
        routerLinkActive="active">
        {{item.label | translate}}
      </a>
      }
      }
    </mat-nav-list>
  </mat-sidenav>
  <div class="wrapper">
    <div class="toolbar">
      <mat-toolbar color="primary" class="tenant-bg-primary-color">
        <button mat-icon-button class="d-md-none" (click)="sidenav.open()">
          <mat-icon>menu</mat-icon>
        </button>
        <span routerLink="/inspections" class="branding spacer d-inline d-sm-none text-center">
          <div class="tenant-logo"></div>
        </span>
        <span routerLink="/inspections" class="branding spacer d-none d-sm-inline d-md-none text-center">
          <div class="tenant-logo"></div>
        </span>
        <span routerLink="/inspections" class="branding spacer d-none d-md-inline">
          <div class="tenant-logo"></div>
        </span>
        @if (userService?.isAuthenticated) {
        <span class="d-none d-md-inline">
          @for (item of navigation; track item) {
          @if (item.isMenu) {
          <button mat-button [matMenuTriggerFor]="navigationMenu" [matMenuTriggerData]="item" class="nav-button"
            [inspektRequiredPermission]="item.permissions">
            {{item.label | translate}}
          </button>
          }
          <mat-menu #navigationMenu="matMenu" class="nav-menu" [overlapTrigger]="false">
            <ng-template matMenuContent let-items="items">
              @for (item of items; track item) {
              <button mat-menu-item [routerLink]="[item.link]" routerLinkActive="active"
                [inspektRequiredPermission]="item.permissions">
                {{item.label | translate}}
              </button>
              }
            </ng-template>
          </mat-menu>
          @if (!item.isMenu) {
          <button mat-button class="nav-button" [routerLink]="[item.link]" routerLinkActive="active"
            [inspektRequiredPermission]="item.permissions">
            {{item.label | translate}}
          </button>
          }
          }
        </span>
        }
        @if (!userService?.isAuthenticated) {
        <button mat-button class="sign-in-button" (click)="onLoginClick()">
          Sign in
        </button>
        }
        @if (userService?.isAuthenticated) {
        <button class="sign-out-button" mat-button [matMenuTriggerFor]="toolbarUserMenu">
          <mat-icon>person</mat-icon>
          @if (isLogout === false) {
          <span>{{ userService?.currentUser.name }}</span>
          }
        </button>
        }
        <mat-menu #toolbarUserMenu="matMenu" [overlapTrigger]="false">
          <inspekt-material-button (click)="showChangeLanguageDialog()" [data]="{
                                                id: 'localisationButton',
                                                permissions: inspektRequiredPermissions,
                                                icon: 'language',
                                                title: 'COMMON.CURRENT_LANG_NAME' | translate
                                            }" />
          <button mat-menu-item (click)="onLogoutClick()">
            <mat-icon>power_settings_new</mat-icon>
            <span>{{'NAVIGATION.LOGOUT' | translate}}</span>
          </button>
        </mat-menu>
      </mat-toolbar>
    </div>
    <div class="content" [@routerTransition]="o.isActivated && o.activatedRoute.routeConfig.path">
      <router-outlet (deactivate)="onDeactivate()" #o="outlet" />
    </div>
    @if (false) {
    <div class="footer tenant-bg-primary-color">
      <div class="row">
      </div>
    </div>
    }
  </div>
</mat-sidenav-container>
}